import sortBy from "lodash/sortBy";

import {
  required,
  length,
  maxLength,
  zip,
  email,
  phone
} from "@/utils/validations";
import withValidation from "@/mixins/withValidation";
import {
  COUNTRIES_SELECT_LIST,
  COUNTRIES_SELECT_LIST_WITH_FLAG
} from "@/constants/select";

const { validateState, validateZip } = withValidation.methods;

/**
 * FIELDS FOR DIFFERENT FORMS.
 */

// Address fields
const addressFormFields = [
  {
    label: "Company",
    placeholder: "SpaceX",
    name: "company",
    classType: "primary"
    // validate: [required]
  },
  {
    name: "country",
    label: "Country",
    classType: "dark",
    selectItems: [
      { label: "US", key: "US", value: "US", img: "./assets/img/flags/US.png" },
      ...sortBy(
        COUNTRIES_SELECT_LIST_WITH_FLAG.filter(item => item.key !== "US"),
        "key"
      ).map(item => ({
        ...item,
        label: item.key
      }))
    ],
    defaultValue: "US",
    placeholder: "e.g. US",
    layout: "half",
    validate: [required],
    withFilter: true,
    elementType: "vue-select",
    isRequired: true,
    extraClass: "noThumbnailsBorder"
  },
  {
    label: "Address Line 1",
    placeholder: "e.g. 1 Rocket Road",
    name: "street",
    classType: "primary",
    validate: [required, maxLength(64)],
    isRequired: true
  },
  {
    label: "Address Line 2",
    placeholder: "e.g. Suite 1",
    name: "unit",
    classType: "primary",
    validate: [maxLength(64)]
  },
  {
    label: "City",
    placeholder: "e.g. Hawthorne",
    name: "city",
    classType: "primary",
    layout: "half",
    validate: [required, maxLength(200)],
    isRequired: true
  },
  {
    label: "State / Province / Region",
    placeholder: "e.g. CA",
    name: "state",
    classType: "primary",
    layout: "half",
    validate: [required, validateState],
    isRequired: true
  },
  {
    label: "ZIP",
    placeholder: "e.g. 90250",
    name: "zip",
    classType: "primary",
    layout: "half",
    validate: [required, validateZip],
    isRequired: true
  }
];

//address from which using for account
const accountAddressFormFields = [
  {
    label: "Company",
    placeholder: "SpaceX",
    name: "company",
    classType: "primary",
    layout: "half",
    isRequired: true,
    validate: [required, maxLength(40)]
  },
  {
    name: "country",
    label: "Country",
    classType: "dark",
    selectItems: [
      { label: "US", key: "US", value: "US", img: "./assets/img/flags/US.png" },
      ...sortBy(
        COUNTRIES_SELECT_LIST_WITH_FLAG.filter(item => item.key !== "US"),
        "key"
      ).map(item => ({
        ...item,
        label: item.key
      }))
    ],
    defaultValue: "US",
    placeholder: "e.g. US",
    layout: "half",
    validate: [required],
    withFilter: true,
    elementType: "vue-select",
    isRequired: true,
    extraClass: "noThumbnailsBorder"
  },
  {
    label: "Address Line 1",
    placeholder: "e.g. 1 Rocket Road",
    name: "street",
    classType: "primary",
    validate: [required, maxLength(64)],
    isRequired: true
  },
  {
    label: "Address Line 2",
    placeholder: "e.g. Suite 1",
    name: "unit",
    classType: "primary",
    validate: [maxLength(64)]
  },
  {
    label: "City",
    placeholder: "e.g. Hawthorne",
    name: "city",
    classType: "primary",
    layout: "half",
    validate: [required, maxLength(200)],
    isRequired: true
  },
  {
    label: "State / Province / Region",
    placeholder: "e.g. CA",
    name: "state",
    classType: "primary",
    layout: "half",
    validate: [required, validateState],
    isRequired: true
  },
  {
    label: "ZIP",
    placeholder: "e.g. 90250",
    name: "zip",
    classType: "primary",
    layout: "half",
    validate: [required, validateZip],
    isRequired: true
  }
];
const billingAddressFormFields = [
  {
    name: "billing_contact_full_name",
    label: "Billing Contact Full Name",
    validate: [required, maxLength(40)],
    isRequired: true
  },
  {
    name: "address_country",
    label: "Billing Address Country",
    classType: "dark",
    selectItems: [
      { label: "US", key: "US", value: "US" },
      ...sortBy(
        COUNTRIES_SELECT_LIST.filter(item => item.key !== "US"),
        "key"
      ).map(item => ({
        ...item,
        label: item.key
      }))
    ],
    defaultValue: "US",
    placeholder: "e.g. US",
    layout: "half",
    validate: [required],
    withFilter: true,
    elementType: "select",
    isRequired: true
  },
  {
    label: "Billing Address Line 1",
    placeholder: "e.g. 555 Avocado St.",
    name: "address_line_1",
    classType: "primary",
    validate: [required, maxLength(64)],
    isRequired: true
  },
  {
    label: "Billing Address Line 2",
    placeholder: "e.g. Suite 700",
    name: "address_line_2",
    classType: "primary",
    validate: [maxLength(64)]
  },
  {
    label: "Billing Address City",
    placeholder: "e.g. Newport Beach",
    name: "address_city",
    classType: "primary",
    layout: "half",
    validate: [required, maxLength(200)],
    isRequired: true
  },
  {
    label: "Billing Address State",
    placeholder: "e.g. CA",
    name: "address_state",
    classType: "primary",
    layout: "half",
    validate: [required, validateState],
    isRequired: true
  },
  {
    label: "Billing Address ZIP",
    placeholder: "e.g. 65000",
    name: "address_zip",
    classType: "primary",
    layout: "half",
    validate: [required, validateZip],
    isRequired: true
  },
  {
    elementType: "telInput",
    name: "billing_phone",
    label: "Billing Phone",
    validate: [required],
    isRequired: true
  },
  {
    name: "billing_email",
    label: "Billing Email",
    placeholder: "Add email...",
    validate: [required, email],
    isRequired: true
  }
];

// General info fields
const generalInfoFormFields = [
  {
    label: "First Name",
    placeholder: "Enter First Name",
    name: "firstName",
    classType: "primary",
    validate: [required, maxLength(19)],
    isRequired: true
  },
  {
    label: "Last Name",
    placeholder: "Enter Last Name",
    name: "lastName",
    classType: "primary",
    validate: [required, maxLength(19)],
    isRequired: true
  },
  {
    label: "Company",
    placeholder: "SpaceX",
    name: "company",
    classType: "primary"
  },
  {
    elementType: "telInput",
    name: "phone",
    label: "Phone"
    // validate: [required],
    // isRequired: true
  },
  {
    name: "email",
    label: "Email",
    placeholder: "Add email...",
    validate: [email]
    // isRequired: true
  }
];

/**
 * Return initial template opts
 * NOTE: it's required to add `name` and `type` fields before proceed!
 * @param type
 * @returns {*}
 */
const getDefaultTemplateOpts = (type = "postcard") => {
  if (type === "letter") {
    return {
      color: false,
      double_sided: false,
      address_placement: "top_first_page",
      type: "html"
    };
  }

  return {
    orientation: "landscape",
    front_html: "<html></html>",
    back_html: "<html></html>",
    front: {
      kind: "ContainerWidget",
      position: {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        zIndex: 0
      },
      padding: 0.125,
      children: []
    },
    back: {
      kind: "ContainerWidget",
      position: {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        zIndex: 0
      },
      padding: 0.125,
      children: []
    }
  };
};

const apiToFormFieldNamesMap = name => {
  switch (name) {
    case "contact":
      return {
        address_zip: "zip",
        address_country: "country",
        address_state: "state",
        address_street: "street",
        address_city: "city",
        address_unit: "unit",
        company: "company",
        custom_data: "customData",
        tags: "tags",
        first_name: "firstName",
        last_name: "lastName"
      };

    case "address":
      return {
        address_zip: "zip",
        address_country: "country",
        address_state: "state",
        address_street: "street",
        address_city: "city",
        address_unit: "unit",
        company: "company"
      };

    default:
      return {};
  }
};

const PAGES_OPTIONS = [
  { value: "one_sided", label: "One Sided" },
  { value: "double_sided", label: "Double Sided" }
];

const COLOR_OPTIONS = [
  { value: "b&w", label: "Black & White" },
  { value: "color", label: "Color" }
];

const POSTAGE_OPTIONS = [
  { value: "usps_first_class", label: "USPS First Class" },
  { value: "usps_standard", label: "USPS Standard" }
];

const EXTRA_POSTAGE_OPTIONS = [
  { value: null, label: "None" },
  {
    value: "certified",
    label: "Certified Mail",
    hintText:
      "Provides electronic verification that an article was delivered or that a delivery attempt was made.\n" +
      "Certified mail is dispatched and handled in transit as ordinary mail. Only available for US. Extra costs incurred vary based on your account's pricing plan."
  },
  {
    value: "certified_return_receipt",
    label: "Certified Mail With Electronic Return Receipt",
    hintText:
      "Instead of signing the green card return receipt, the person receiving the Certified Mail letter signs a receipt from USPS with the date, time, signature, and must spell out their name.",
    extraClass: "wide"
  },
  {
    value: "registered",
    label: "Registered Mail",
    hintText:
      "Registered mail is an add-on service that provides extra protection for high-value letters and packages. When you send a letter by Registered Mail, the provider establishes a chain of custody that tracks and secures your shipment throughout the entire transit process."
  }
];

const POSTCARDS_SIZES_OPTIONS = [
  { value: "postcard-4x6", label: "4x6" },
  { value: "postcard-6x9", label: "6x9" },
  { value: "postcard-6x11", label: "6x11" }
];

export {
  addressFormFields,
  accountAddressFormFields,
  billingAddressFormFields,
  generalInfoFormFields,
  getDefaultTemplateOpts,
  apiToFormFieldNamesMap,
  PAGES_OPTIONS,
  COLOR_OPTIONS,
  POSTAGE_OPTIONS,
  EXTRA_POSTAGE_OPTIONS,
  POSTCARDS_SIZES_OPTIONS
};
